<template>
    <thead class="no_sortable">
    <tr>
        <th v-if="dragDrop" class="no_padding drag_drop"></th>
        <th v-if="checkbox" class="no_padding checkbox"></th>
        <th v-for="(title, index) in titles" :class="getThClasses(index)">
            <span class="name">{{ title }}</span>
        </th>
        <th v-if="editColumn" class="no_padding edit"></th>
    </tr>
    </thead>
</template>

<script>
	export default {
		name: "NotSortingTableHeader",
		props: {
			titles: Array,
			dragDrop: {
				type: Boolean,
				default: false,
			},
			checkbox: {
				type: Boolean,
				default: false,
			},
			useRight: {
				type: Boolean,
				default: true,
			},
			thClasses: {
				type: Object,
				default: () => {
					return {}
				}
			},
            editColumn: {
				type: Boolean,
                default: true
            },
		},
		methods: {
			isRight(index) {
				return this.useRight && index === (this.titles.length - 1)
			},
			getThClasses(index) {
				let right = this.isRight(index) ? 'right' : ''
				return [right, this._.has(this.thClasses, index) ? this.thClasses[index] : '']
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/common/NotSortingTableHeader.vue